export default () => ({
  all: [],
  current: null,
  meta: {
    next: null,
    previous: null,
    rowCount: 0,
    total: 0,
  },
});
